<template>
<div>



  <div class="container">
    <!-- 全体ローディング -->
     <t-loading class="loading-words" :isLoading="isLoadingWords"></t-loading>
    <!-- 言葉一覧 -->
    <div class="words">
    <draggable handle=".drag-handle"  element="div" v-model="words"   
         @start="onMoveStartCallback" @end="onMoveEndCallback">
        <transition-group name="demo"   mode="out-in" type="transition"> 
          <!-- <transition-group v-on:enter="enterTransition"> -->
          <!-- <div v-bind:class="{contain: ContainContents(item),disable:item.isLoading,edit_state:OnEditMode}"  -->
          <div v-bind:class="{contain: ContainContents(item),disable:item.isLoading,selected: currentWord != null && item.id === currentWord.id}"
          :key="item.id"
          v-for="(item,index) in words" class="word-box"  >

              <span class="drag-handle">
                <i class="fas fa-ellipsis-v"></i>
                <i class="fas fa-ellipsis-v"></i>
                <i class="fas fa-ellipsis-v"></i>
              </span>

                <span  >
                <i v-show="ContainContents(item)"  class="fas fa-comment-dots"></i>
                <span class="number">{{index + 1}}</span> 
                <span 
                v-bind:contenteditable="true !== item.isLoading"
                @keydown.enter="EndEditWord(item,index,$event)"
                @keyup.esc="CancelEditWord(item,index,$event)"
               @blur="OnBlurInWord(item,index,$event)"
                class="word-item word-item-edit-mode">{{ item.main }}</span>
              </span>
              <span class="c-btn-detail" tooltip="詳細を表示" @click="SelectWord(item,index)">
              <!-- <i class="fas fa-chevron-right" ></i> -->
               <i class="fas fa-angle-double-right"></i>
              </span>
  　          <!-- ローディング -->
              <!-- <t-loading class="loading" :isLoading="item.isLoading" color="#ff6600"></t-loading> -->
              <!-- 削除ボタン -->
              <!-- <span  class="btn-delete" @click="RemoveWord(item);">
                <i class="fas fa-times-circle"></i>
              </span> -->
              
            </div>
         </transition-group>


    </draggable>
    <!-- 新規追加:ローディング -->
    <!-- <div  class="item-for-loading word-box" v-if="isAddingLoading">
        <t-loading class="loading-item" isLoading="true" color="#ff6600"></t-loading>
    </div> -->
    </div>

     <!-- 新規追加:ローディング -->
    <div  class="item-for-loading " v-if="isAddingLoading">
        <t-loading class="loading-item" isLoading="true" color="#d4d4d4"></t-loading>
    </div>
    


　       
    

  </div>


  <!-- 入力欄：言葉 -->
  <div class="input-container bottom">
     <t-input v-model="word"
              v-bind:class="{disable:isLoadingWords}"
              label=""
              ref="inputWord"
              placeholder="きみから生まれた「ことば」をとうろく"
              style="margin-bottom:10px;"
              v-on:edited="AddWord"
              iconClassName="fas fa-comment-dots"
              radius="26px"
              :enterToEditEnd =true
              ></t-input> 
  </div>
  
  <t-dialog :show="showModal" @ok="ModalCallback('ok')" @cancel="ModalCallback('cancel')">
    <template slot="header" >
      <i class="fa  fa-exclamation-circle " style="display: inline-block; margin-right: 5px;font-size:18px;">&nbsp;</i>
    かくにん
</template>
  <template slot="body" >
    なかみがあるよ。消してもいい？
  </template>
 </t-dialog>
  
  </div>
</template>

<script>
import draggable from "vuedraggable";
import anime from "animejs";
import TInput from "./TInput";
import Tloading from "./TLoading";
import TDialog from "./TDialog";



export default {
  name: "words-component",
  props: ["title"],
  components: {
    draggable,
    TInput,
    TDialog,
    "t-loading": Tloading
  },
  directives: {
    "todo-focus": function(el, binding) {
      if (binding.value) {
        el.focus();
      }
    }
  },
  computed: {
    words: {
      get() {
        return this.$store.getters.thinkData.words;
      },
      set(value) {
        this.$store.commit("SetWords", value);
      }
    },
    isLoadingWords: {
      get() {
        return this.$store.getters.Loading.Words;
      }
    },
    currentWord:{
      get() {
      return this.$store.getters.activeWord;
    }
    },
    limitForAdd:{
      get(){
        return this.$store.getters.LimitForSave.words;
      }
    }
  },
  methods: {
    enterTransition(el, done) {
      alert(el);
    },
    ModalCallback(text) {
      this.showModal = false;
    },
    onMoveStartCallback(evt) {},
    //==========================
    //ドラッグ後の処理
    //==========================
    onMoveEndCallback(evt) {
      if (evt.newIndex == evt.oldIndex) {
        return;
      }
      this.$store.dispatch("UpdateWordOrder");
    },
    getData() {
      this.ht = this.quillWords.root.innerHTML;
      this.words.push(this.quillWords.root.innerHTML);
    },
    ContainContents(item) {
      if (item.really === "" && item.so === "" && item.why === "") {
        return false;
      }
      return true;
    },
    //==========================
    //word-item：ブラー時に必ず呼ばれる。
    //==========================
    OnBlurInWord(editedItem, index,e) {

      if(editedItem.main !==e.target.textContent)
      {
        //new: 内容がすべて削除された場合は「削除処理」をおこなう
        if(e.target.textContent ==="")
        {
          // EnterKey > EndEditWordで削除されている場合は、何も処理をしない
          if(editedItem.removed)
          {
            return;
          }
          //Remove処理がfalseの場合は内容をもとに戻す
          if(false === this.RemoveWord(editedItem))
          {
            e.target.textContent = editedItem.main;
          }
          return;
      }
        editedItem.main = e.target.textContent
        this.UpdateWord(editedItem)
      }
    },
    //==========================
    //word-item：編集-完了処理
    //==========================
    EndEditWord(editedItem, index,e) {

      // 日本語入力中のEnterキー操作は無効にする
      if(e.keyCode!==13) {
        return;
      }

      //編集前と内容が変わらない場合は何もしない
      if(editedItem.main ===e.target.textContent)
      {
        return;
      }

      //new: 内容がすべて削除された場合は「削除処理」をおこなう
      if(e.target.textContent === "")
      {
        //Remove処理がfalseの場合は内容をもとに戻す
        if(false === this.RemoveWord(editedItem))
        {
          e.target.textContent = editedItem.main;
        }else{
          editedItem.removed = true; // このフラグをたてることで、Blur時のイベントOnBlurInWordで削除処理を重複してしないようにする目印になっている
        }
        e.target.blur();
        return;
      }

      editedItem.main = e.target.textContent
      this.UpdateWord(editedItem);
      //編集後は要素をブラーして編集状態を解除する。
      //*編集状態解除とは？編集中cssスタイルや、contenteditableをfalseにする
      e.target.blur();
    },
    //==========================
    //word-item：編集-キャンセル
    //==========================
    CancelEditWord(editedItem, index,e) {
      e.target.textContent = editedItem.main;
      e.target.blur();
      
    },
    //==========================
    //word-item：更新処理
    //==========================
    UpdateWord(item){
      this.$store.dispatch("UpdateWordMain", item);
    },
    //==========================
    //word-item：新規追加
    //==========================
    AddWord() {
      if (this.word.length == 0) {
        return;
      }

      //データ入力制限
      if(this.words.length >= this.limitForAdd)
      {
        alert("ごめんね！「ことば」は最大"+this.limitForAdd + "こまでだよ。")
        return;
      }


      this.isAddingLoading = true;
      var itemIndex = this.words.length + 1; // 並び順を指定:一番最後
      var item = {
        index: itemIndex,
        main: this.word,
        why: "",
        really: "",
        so: ""
      };

      var callback = function() {
        this.isAddingLoading = false;
      }.bind(this);

      this.$store.dispatch("AddWord", {
        main: this.word,
        index: itemIndex,
        callback: callback
      });
      this.word = "";
      this.$store.getters.thinkData.wordsCount += 1;
    },
    //==========================
    //word-item：削除
    //==========================
    RemoveWord(item) {
      this.$set(item, "isLoading", true); //Notice:リアクティブにするためのプロパティを追加して、有効にしている
      if (item.really != "" || item.so != "" || item.why != "") {
        if (false == window.confirm("なかみがあるよ。消してもいい？")) {
          item.isLoading = false;
          return false;
        }
      }

      this.$store.dispatch("RemoveWord", item);

      this.$store.getters.thinkData.wordsCount -= 1;
    },
    //==========================
    //word-item：選択
    //==========================
    SelectWord(item, index) {
      item.index = index + 1;//Notice:
      this.$emit("selectWord", item);
    },

    ConfigAnime(){

      //TODO: 新しい要素が追加された際、その要素にもアニメーションを効かすにはどうするか？
      this.animationSets.bulubulu = anime({
          targets: ".word-box",
          //translateX: [{ value: 100, duration: 1200 }, { value: 0, duration: 800 }],
          rotate: [0,1,0,-1,0],
          elasticity: 100,
          //rotate: 2,
         // translateX: 250,
          //direction: 'al',
          duration: 300,
          loop: true,
          autoplay: false // 自動再生を禁止します。
       });

    },
    
  },
  //==========================
  //
  //
  //==========================
  data() {
    return {
      word: "",
      ht: "",
      quillWords: null,
      showModal: false,
      isAddingLoading: false,
      //アニメーションのセット
      animationSets:{
        bulubulu :null
      }
    };
  },
  watch: {

  },
  //==========================
  //
  //
  //==========================
  mounted() {
    
     this.$refs.inputWord.ToFocus();
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//---------------
// :無効時のスタイル
//---------------
.disable {
  opacity: 0.3;
  cursor: default;
  pointer-events: none; // クリック、タッチを無効化
  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}


.demo-enter-active {
  transition: transform 0.4s, opacity 0.5s;
}
.demo-move:not(.demo-leave-active) {
  transition: transform 0.5s;
}
.demo-move {
  transition: none !important; //vueDraggableのドラッグ後のTransitionを消す
}

/* 消える時は縮小される */
.demo-leave-active {
  transition: transform 0.5s, opacity 0.5s;
}
/* 表示される時は上からスライド */
.demo-enter {
  opacity: 0;
  transform: scale(0.6);
}

//削除:開始前
.demo-leave {
  opacity: 1;
}
//終了状態
.demo-leave-to {
  opacity: 0;
  //transform: scaleY(0);
  transform: scale(0.1);
}

.container {
  display: flex;
  position: relative;
  background: #f2faf6;
  border: 2px solid #573F23;
  align-items: stretch;
  border-radius: 16px;
}

//=====================
//
//=====================
.words {
  padding: 15px 20px 30px 20px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
  min-height: 200px;
}
.title {
  padding: 20px;
  font-weight: 600;
}
.button {
  background: rgb(241, 241, 146);
}

// .sortable-chosen {
//   opacity: 1;
//   background: transparent;
// }

// .sortable-chosen.sortable-ghost {
//   opacity: 1 !important;
//   background: transparent;
// }

.word-box {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  //cursor: pointer;

  // -文字を選択させない
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  
  // OSブラウザでタップした要素が自動的に暗くなるのを防止する
  -webkit-tap-highlight-color:transparent; 


  
  
  //タップ時の色
  //transition: 0.15s;
  &:active{
    &.contain  .word-item{ 
      color:rgb(241, 241, 146)!important;
    }
    &:not(.contain)  .word-item{
      color:coral;
    }
    &.contain  .number{ 
      color:rgb(241, 241, 146)!important;
    }
    &:not(.contain)  .number{
      color:coral;
    }
  }

  //---------------
  // word-box:選択時のスタイル
  //---------------
  &.selected{
    &.contain{
      color:rgb(241, 241, 146);
    }
    &:not(.contain){
      color:coral;
    }
     &.contain  .number{ 
      color:rgb(241, 241, 146)!important;
    }
    &:not(.contain)  .number{
      color:coral;
    }
    //background:yellow;
      
    
  }

  

  //---------------
  // word-box:無効時の処理
  //---------------
  &.disable {
    opacity: 0.7;
    cursor: default;
    pointer-events: none; // クリック、タッチを無効化
    // -文字を選択させない
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  .word-item{
    
    // OSブラウザでタップした要素が自動的に暗くなるのを防止する
    //-webkit-tap-highlight-color:transparent; 
     &:focus{
      outline:none;
    }
    
  }

  border-radius: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 0px;
  background-color: white;
  color: #333333;
  display: inline-block;
  margin-left: 8px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #39af78;
  box-shadow: 0px 1px #ccc;
  

  //:編集中のスタイル
  &.edit_state {
    //常時アニメーションにした場合、vueのトランジションとガチンコして
    //vueのトランジションが動かなくなる
    //animation: jiggle 0.3s infinite;
  }


  //:データを含んでいる言葉のスタイル
  &.contain {
    font-size: 16px;
    font-weight: 800;
    //background: #71BAD8;
    background: #39af78;
    color: white;
    text-shadow: 1px 2px 0px #666; 

    .number{
      color:white;
    }

    .btn-delete {
      & > i {
        color:white;
        background: #39af78;
      }
      &:hover {
        color: white;
        & > i {
          //background: coral;
        }
      }
    }
  }

  //----------------
  //word-box:ドラッグゴースト
  //----------------
  &.sortable-chosen.sortable-ghost {
    background-color: gray;
    border: 1px solid gray;
    color: white;
    //animation: jiggle 0.3s infinite;
  }
  &.sortable-chosen {
    opacity: 1 !important;
    //Notice:ドラッグ時に表示される画像イメージに背景色が残ったままになるのを防ぐための処置
    //refs https://github.com/react-dnd/react-dnd/issues/788
    transform: translate(0, 0);
    box-shadow: 0px 4px #39af78;
  }


  & > p {
    margin: 50px;
    padding: 0;
  }
  .number {
    font-weight: bold;
    font-size:12px;
    margin-right: 5px;
    color: #999;
  }

  //----------------
  //削除ボタン
  //----------------
  .btn-delete {
    position: absolute;
    top: -10px;
    right: -5px;
    font-size: 20px;

    & > i {
      color:#39af78;
      background: white;
      border-radius: 50%;
      height: 1em;
      width: 1em;
    }
    z-index: 999;
    &:hover {

      & > i{
        color: coral!important;

      }
      
    }
  }

  @keyframes jiggle {
    0% {
      transform: rotate(-1deg);
    }
    50% {
      transform: rotate(1deg);
    }
  }

  @keyframes buruburu {
    0% {
      transform: translate(0px, 0px) rotateZ(0deg);
    }
    25% {
      transform: translate(2px, 2px) rotateZ(1deg);
    }
    50% {
      transform: translate(0px, 2px) rotateZ(0deg);
    }
    75% {
      transform: translate(2px, 0px) rotateZ(-1deg);
    }
    100% {
      transform: translate(0px, 0px) rotateZ(0deg);
    }
  }
}

.loading {
  position: absolute;
  bottom: -17px;
  right: -4px;
  z-index: 999;
  transform: scale(0.7);
}
.loading-words {
  //transform: scale(1.5);
  position: absolute;
  top: 20px;
  left: 20px;
}

// .item-for-loading {
//   position: relative;
//   text-align: left;
//   border: 0px;
//   margin-bottom: -1px; //Notice:アイテム間のborderが太くなるのを防ぐ。
//   padding-left: 10px;
//   display: flex;
//   cursor: none;
//   background: transparent;
//   justify-content: center;
//   align-items: center;
//   transition: 0.4s;
//   .loading-item {
//     transform: scale(0.8);
//   }
// }

//----------------
  //ローディング：新規追加
  //----------------

.item-for-loading {
  position: absolute;
  text-align: left;
  border: 0px;
  margin-bottom: -1px; //Notice:アイテム間のborderが太くなるのを防ぐ。
  padding-left: 10px;
  display: flex;
  bottom:5px;
  left:20px;
  cursor: none;
  background: transparent;
  justify-content: center;
  align-items: center;
  transition: 0.4s;
  .loading-item {
    transform: scale(0.8);
  }
}


//=======================
//word-item:編集中
//=======================
  .word-item-edit-mode{
    //what: contenteditable設定で発生する枠線を消している
    border: none;
    outline-width: 0;
    display: inline-block; // 編集文字が空白時にふきだしの左はしに移動してしまうのをふせぐ
    min-width: 5px;
  
    &:focus{
      color:coral;
    }

    // iOSでタップしても編集できないのを防ぐ。
    -webkit-user-select: text;
    user-select: text;
  }

//=======================
//編集中スイッチのコンテナ
//=======================
  .edit-mode-switch-container{
    margin-bottom:10px;
    cursor:pointer;
    height:34px;
    display: inline-block;
    padding-right:6px;
    &:hover{
      & > span.label{
        opacity:0.6;
      }
    }

    rt{
        transform: scale(0.8);
       
    }
    //ラベル
    & > span.label{
      margin-left:1px;
      display: inline-block;
      margin-top:6px;
      color:#666;

      
      // ラベル:編集時
      &.edit{
        color:coral;
        font-weight: 600;
      }
    }
  }
 //---------------
  // :ドラッグハンドル
  //---------------
  .drag-handle
  {
    cursor: grab;
    align-items: center;
    justify-content: center;
    font-size:12px;
    letter-spacing: -2px;
    text-align: center;
    color:#ccc;
    //text-shadow: 1px 2px 0px #ccc;
    margin-right:6px;
  }

  .c-btn-detail{
      font-size:14px;
      color:#666;
      text-align: center;
      cursor: pointer;
      & > i{
        margin-right:10px;
        margin-left:10px;
      }
      &:hover{
        color:coral;
      }

    }

</style>



// WEBPACK FOOTER //
// src/components/Words.vue